module.exports = __webpack_public_path__ + "static/contribution_img1_on@2x-d74e86b4e5c2f57f3f70f3b9dfbede5d.jpg";